import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// TODO: Replace search input w/ icon input -- can happen at a later date.
// TODO: Consider throwing an error in NODE_ENV dev if this is not given a text input
import './icon-input.scss';

/*
  Takes an input as a child element, and sets it up with a nice inline icon a la the search input

  Ex:
    <IconInput
      iconClass={'fa fa-search'}
      onIconClick={this.handleSubmit}
    >
      <TextInput
        placeholder='Type Email or Username...'
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        value={userResultsStore.getQueryString()}
        type='text'
      />
    </IconInput>

  wow
*/

type IconInputProps = {
  onIconClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  iconClass: string;
  iconTitle?: string;
  className?: string;
  ariaLabel?: string; // TOOD: this field should be required
};

export default class IconInput extends React.Component<IconInputProps> {
  static propTypes = {
    onIconClick: PropTypes.func.isRequired,
    iconClass: PropTypes.string.isRequired,
    iconTitle: PropTypes.string,
    className: PropTypes.string,
    ariaLabel: PropTypes.string
  };

  static defaultProps = {
    ariaLabel: '',
    className: '',
    iconTitle: ''
  };

  handleSearchOnEnterKeyPress = (e) => {
    if (this.props.onIconClick && e.which === 13) {
      this.props.onIconClick();
    }
  };

  render() {
    return (
      <div className={classnames('icon-input-wrapper', this.props.className)}>
        {this.props.children &&
          React.isValidElement(this.props.children) &&
          React.cloneElement(this.props.children, {
            // stacking classnames. icon-input is required for this to play nice
            className: classnames('icon-input', this.props.children.props.className)
          } as IconInputProps)}
        <button
          type='button'
          className='unbutton icon-input-button'
          aria-label={this.props.ariaLabel}
          onClick={this.props.onIconClick}
          onKeyDown={this.handleSearchOnEnterKeyPress}
        >
          <span
            className={`${this.props.iconClass} icon-input-button__icon`}
            aria-hidden='true'
            title={this.props.iconTitle}
          />
        </button>
      </div>
    );
  }
}
